<template>
  <div
    class="w-full md:w-auto flex flex-row lg:flex-col lg:min-w-[264px] gap-3"
  >
    <CButton
      v-for="(el, idx) of menu"
      :key="idx"
      variant="transparent"
      size="lg"
      :text="$t(el?.title)"
      class="!rounded-3xl hidden md:flex"
      @click="handleProfileRoute(el?.tab)"
      :class="{ '!border-gray-0': currentTab === el?.tab }"
    />
    <FSelect
      :options="menu"
      v-model="tab"
      label-key="title"
      value-key="tab"
      head-styles="w-full"
      class="!w-full flex md:hidden"
    />
  </div>
</template>

<script setup lang="ts">
import FSelect from "@/components/Form/Select/FSelect.vue";
import CButton from "@/components/Common/CButton.vue";
import { useRoute } from "vue-router";
import { computed, ref, watch } from "vue";

interface Props {
  menu: {
    title: string;
    tab: string;
  }[];
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "changeProfileRoute", value: string): void;
}>();

const route = useRoute();

const currentTab = computed(() => route.query.profile);
const tab = ref(currentTab.value);

const handleProfileRoute = (tab: string) => {
  emit("changeProfileRoute", tab);
};
watch(
  () => tab.value,
  (val: string) => {
    emit("changeProfileRoute", val);
  },
);
</script>

<style scoped></style>
